import { Component, Input } from "@angular/core";

@Component({
	selector: "app-skeleton-loader",
	templateUrl: "./skeleton-loader.component.html",
	styleUrls: ["./skeleton-loader.component.scss"],
})
export class SkeletonLoaderComponent {
	@Input() height: number;

	constructor() {}
}
